// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.summaryPanel__EJoLU {
  width: 100%;
  background: var(--tables-primary-row-surface-default);
  padding: 25px;
  display: flex;
  gap: 50px;
  border: 1px solid var(--header-stroke);
  border-top: unset;
}

.totalSensors__MP3Vi {
  display: flex;
  gap: 10px;
  flex: 0 0 234px;
}

.totalLabel___FBqy {
  color: var(--title-inputs-sections-title);
  font-family: Roboto;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  text-transform: uppercase;
}

.summaryValue__LioTh {
  color: var(--legend-for-header-text);
  text-align: right;
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 12px;
  text-transform: uppercase;
}

.sensorSummaryList__zYZro {
  align-self: center;
  flex-wrap: wrap;
  gap: 20px;
  display: flex;
}

.sensorSummary__ck0uX {
  display: flex;
  gap: 10px;
}

.skeletonTitleText__bJtQb {
  height: 24px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/ManageEquipment/components/SensorTypeSummaryPanel/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,WAAA;EACA,qDAAA;EACA,aAAA;EACA,aAAA;EACA,SAAA;EACA,sCAAA;EACA,iBAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,SAAA;EACA,eAAA;AAzEF;;AA4EA;EACE,yCAAA;EAEA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AA1EF;;AA6EA;EACE,oCAAA;EACA,iBAAA;EAEA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AA3EF;;AA8EA;EACE,kBAAA;EACA,eAAA;EACA,SAAA;EACA,aAAA;AA3EF;;AA8EA;EACE,aAAA;EACA,SAAA;AA3EF;;AA8EA;EACE,YAAA;AA3EF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.summaryPanel {\n  width: 100%;\n  background: var(--tables-primary-row-surface-default);\n  padding: 25px;\n  display: flex;\n  gap: 50px;\n  border: 1px solid var(--header-stroke);\n  border-top: unset;\n}\n\n.totalSensors {\n  display: flex;\n  gap: 10px;\n  flex: 0 0 234px;\n}\n\n.totalLabel {\n  color: var(--title-inputs-sections-title);\n\n  font-family: Roboto;\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n  text-transform: uppercase;\n}\n\n.summaryValue {\n  color: var(--legend-for-header-text);\n  text-align: right;\n\n  font-family: Roboto;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 12px;\n  text-transform: uppercase;\n}\n\n.sensorSummaryList {\n  align-self: center;\n  flex-wrap: wrap;\n  gap: 20px;\n  display: flex;\n}\n\n.sensorSummary {\n  display: flex;\n  gap: 10px;\n}\n\n.skeletonTitleText {\n  height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"summaryPanel": `summaryPanel__EJoLU`,
	"totalSensors": `totalSensors__MP3Vi`,
	"totalLabel": `totalLabel___FBqy`,
	"summaryValue": `summaryValue__LioTh`,
	"sensorSummaryList": `sensorSummaryList__zYZro`,
	"sensorSummary": `sensorSummary__ck0uX`,
	"skeletonTitleText": `skeletonTitleText__bJtQb`
};
module.exports = ___CSS_LOADER_EXPORT___;
